import { render, staticRenderFns } from "./orderProductionBreakdownWidget.vue?vue&type=template&id=0e8d049a&"
import script from "./orderProductionBreakdownWidget.vue?vue&type=script&lang=js&"
export * from "./orderProductionBreakdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports